import type { DistributionRepeatUnit } from "./DistributionScheduleFields.types";

/** The "Repeats" select; each maps to one contract `kind`. */
export const FREQUENCY_OPTIONS: { value: DistributionRepeatUnit; label: string }[] = [
  { value: "day", label: "Daily" },
  { value: "week", label: "Weekly" },
  { value: "month", label: "Monthly" },
  { value: "quarter", label: "Quarterly" },
];

export const isRepeatUnit = (value: string): value is DistributionRepeatUnit =>
  FREQUENCY_OPTIONS.some((option) => option.value === value);
